"use client";
import AuthButton from "@/components/Auth/AuthButton";
import Link from "next/link";
import useAuthorization from "@/components/Auth/useAuth";
import SpinnerCheck from "@/components/spinner-check";
import { Headset, ShoppingCart, UserPlus, UserX } from "lucide-react";

export default function Home() {
  const { session, isLoaded, canAccessRestrictedForms } = useAuthorization();

  // Not loaded, No Session
  if (!isLoaded && !session)
    return (
      <div className="flex flex-1 items-center justify-center">
        <SpinnerCheck size={"75px"} />
        <h2 className="my-4 text-2xl font-semibold">Logging in...</h2>
      </div>
    );

  // Loaded, No Session
  if (isLoaded && !session)
    return (
      <div className="flex flex-1 flex-col justify-center px-6 pb-20">
        <div className="h-100 w-100">
          <h1 className="text-4xl font-semibold text-center">Welcome!</h1>
          <h4 className="text-lg font-semibold text-center">
            Please sign in to continue
          </h4>
        </div>
        <div className="w-full flex flex-col items-center">
          <div className="w-1/2">
            <AuthButton />
          </div>
        </div>
      </div>
    );

  // Loaded and session
  if (isLoaded && session)
    return (
      <div className="flex min-h-0 flex-1 flex-col px-6 pb-6">
        <div
          className={`mx-auto flex w-full flex-col items-center ${
            canAccessRestrictedForms
              ? ""
              : "flex-1 justify-center -translate-y-8"
          }`}
        >
          <div className="text-center mt-8">
            <h1 className="text-4xl font-semibold">
              Welcome {session.user.givenName}!
            </h1>
            <h4 className="text-lg font-semibold">
              What would you like to get started on?
            </h4>
          </div>

          <div className="flex flex-col gap-4 p-8">
            <Link href="/support">
              <div className="flex w-[450px] items-center rounded-xl border p-4 transition duration-200 hover:scale-105 hover:cursor-pointer hover:bg-gray-100">
                <Headset className="ml-4 mr-6 h-12 w-10 text-primary" />

                <div className="flex-1">
                  <p className="text-lg font-semibold">Support Request</p>
                  <p className="text-sm text-muted-foreground">
                    Reach out to Gazelle for Tech Support
                  </p>
                </div>
              </div>
            </Link>

            {/* User Requests Card */}
            {/* {canAccessRestrictedForms && ( */}
            <div className="flex-1 flex flex-col space-y-4 pr-4 max-w-[450px] mx-auto">
              <Link href="/staff/create">
                <div className="flex items-center w-[450px] border rounded-xl p-4 hover:cursor-pointer hover:bg-gray-100 transform transition duration-200 hover:scale-105">
                  <UserPlus className="w-10 h-12 ml-4 mr-4 text-primary" />
                  <div className="flex-1">
                    <p className="text-lg font-semibold">Add New Staff</p>
                    <p className="text-sm text-muted-foreground">
                      Request to create new staff member accounts
                    </p>
                  </div>
                </div>
              </Link>
              <Link href="/staff/disable">
                <div className="flex items-center w-[450px] border rounded-xl p-4 hover:cursor-pointer hover:bg-gray-100 transform transition duration-200 hover:scale-105">
                  <UserX className="w-10 h-12 ml-4 mr-4 text-primary" />
                  <div className="flex-1">
                    <p className="text-lg font-semibold">Offboard Staff</p>
                    <p className="text-sm text-muted-foreground">
                      Request to offboard an existing staff member
                    </p>
                  </div>
                </div>
              </Link>
              <Link href="/hardware-order">
                <div className="flex items-center w-[450px] border rounded-xl p-4 hover:cursor-pointer hover:bg-gray-100 transform transition duration-200 hover:scale-105">
                  <ShoppingCart className="w-10 h-12 ml-4 mr-4 text-primary" />
                  <div className="flex-1">
                    <p className="text-lg font-semibold">Hardware Order</p>
                    <p className="text-sm text-muted-foreground">
                      Form for ordering new hardware
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            {/* )} */}
          </div>
        </div>
      </div>
    );
}
